import { render, staticRenderFns } from "./Bomba.vue?vue&type=template&id=5d95f554&"
import script from "./Bomba.vue?vue&type=script&lang=js&"
export * from "./Bomba.vue?vue&type=script&lang=js&"
import style0 from "./Bomba.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports